"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchSchema = void 0;
const audit_log_1 = require("./base/audit-log");
const operations_subscription_1 = require("./operations/operations-subscription");
const sourgum_1 = require("./sourgum");
const wayste_1 = require("./wayste");
const wayste_tagged_container_1 = require("./wayste/wayste-tagged-container");
exports.SearchSchema = {
    'sourgum-order': sourgum_1.SourgumOrderSchema,
    'wayste-order': wayste_1.WaysteOrderSchema,
    'sourgum-payable': sourgum_1.SourgumPayableSchema,
    'sourgum-receivable': sourgum_1.SourgumReceivableSchema,
    'wayste-receivable': wayste_1.WaysteReceivableSchema,
    'wayste-payable': wayste_1.WaystePayableSchema,
    'sourgum-customer': sourgum_1.SourgumCustomerSchema,
    'wayste-customer': wayste_1.WaysteCustomerSchema,
    'sourgum-vendor': sourgum_1.SourgumVendorSchema,
    //'wayste-vendor': DisabledSchema, // does not exist but hopefully will soon
    'sourgum-pricing-zone': sourgum_1.SourgumPricingZoneSchema,
    'wayste-pricing-zone': wayste_1.WaystePricingZoneSchema,
    'sourgum-lead': sourgum_1.SourgumLeadSchema,
    'wayste-disposal-site': wayste_1.WaysteDisposalSiteSchema,
    /**
     * @deprecated - use tagged container instead
     */
    'wayste-dumpster': wayste_1.WaysteDumpsterSchema,
    'audit-log': audit_log_1.AuditLogSchema,
    'sourgum-service-grouping': sourgum_1.SourgumServiceGroupingSchema,
    'wayste-commercial-subscription': wayste_1.WaysteCommercialSubscriptionSchema,
    'wayste-tagged-container': wayste_tagged_container_1.WaysteTaggedContainerSchema,
    'operations-subscription': operations_subscription_1.OperationsSubscriptionSchema,
};
//# sourceMappingURL=schema.js.map